<template>
    <b-container class="mb-5">
        <PageHeader :linkto="'/Payment/PlanCart'" :linkttitle="'返回'" title=""></PageHeader>
        <b-row>
            <b-col cols="12" md="8">
                <div class="bg-white px-3 px-md-4 pb-3 pt-3  shadow-sm rounded ">
                    <h3 class="text-primary">付款方式</h3>
                    <hr>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-select v-model="payselected" :options="payway"></b-form-select>
                        </b-col>
                        <b-col cols="12" md="6" class="pt-3 pt-md-0">
                            <b-form-select v-if="payselected=='ATM'" v-model="bankselected"
                                           :options="atmbank"></b-form-select>
                            <div class="pt-2" v-if="payselected=='CREDIT'">
                                <b-img class="float-left mr-3" :src="require('@/assets/ui/visa.png')"
                                       height="20px"></b-img>
                                <b-img class="float-left  mr-3" :src="require('@/assets/ui/master.png')"
                                       height="20px"></b-img>
                                <b-img class="float-left  mr-3" :src="require('@/assets/ui/jcb.png')"
                                       height="20px"></b-img>
                                <!--<b-img class="float-left  mr-3" :src="require('@/assets/ui/ubank.png')"-->
                                <!--height="30px"></b-img>-->
                            </div>
                        </b-col>
                    </b-row>

                    <p v-if="payselected=='CREDIT'" class="mt-2">
                        下一步將連至第三方金流服務進行刷卡，你所有的交易資訊皆獲得安全保護。
                        <b-icon icon="shield-shaded"></b-icon>
                    </p>
                    <p v-if="payselected=='ATM'" class="mt-2">選擇銀行節省跨行轉帳手續費（如果沒有，可以任選一間轉帳，額外負擔 15 元跨行轉帳手續費）<br>
                        <span class="text-danger">若使用第一銀行 ATM，請選擇「繳費」功能，而非「轉帳」功能</span></p>
                </div>
                <div class="bg-white px-3 px-md-4 pb-5 pt-3 mt-3 shadow-sm rounded ">
                    <h3 class="text-primary">發票選項</h3>
                    <hr>
                    <p>以下資訊只用於開立發票，並不會在其他頁面顯示。發票一經開立後不可更改，請確認資訊是否都填寫正確喔！（ <span class="text-danger">*</span> 為必填欄位）</p>
                    <b-button variant="primary" class="mb-2" @click="loadAccountData">帶入帳號個人資料</b-button>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group
                                    class="mb-0"
                            >
                                <label>姓名<span class="text-danger">*</span></label>
                                <b-form-input

                                        v-model="formData.clientname"
                                        placeholder="請填入真實姓名"
                                        @change="checkvalue('name')"

                                ></b-form-input>
                                <b-form-invalid-feedback :state="formData.namecheck">
                                    {{ formData.namemsg }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                        </b-col>
                        <b-col>

                            <b-form-group
                                    class="mb-0"
                            >
                                <label>聯絡用電子信箱<span class="text-danger">*</span></label>
                                <b-form-input

                                        v-model="formData.clientmail"
                                        placeholder="請填入電子信箱"
                                        @change="checkvalue('email')"
                                ></b-form-input>
                                <b-form-invalid-feedback :state="formData.emailcheck">
                                    {{ formData.emailmsg }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                        </b-col>

                    </b-row>
                    <label class="pt-4">發票類型 <span class="text-danger">如需開立統編，請選擇統編發票</span></label>
                    <b-row>

                        <b-col cols="12" md="6">
                            <b-form-group
                                    class="mb-0"
                            >
                                <b-form-select v-model="einselected" :options="einvoice"></b-form-select>
                            </b-form-group>

                        </b-col>
                        <b-col cols="12" md="6">

                            <b-form-group
                                    class="mb-0 mt-3 mt-md-0"
                                    label=""
                            >

                                <b-form-select v-if="einselected=='EINVOICE'" v-model="eivcodeselected"
                                               :options="einvoicecode"></b-form-select>
                                <b-form-select v-if="einselected=='DONATION'" v-model="donationselected"
                                               :options="donatuonorg"></b-form-select>
                            </b-form-group>

                        </b-col>
                    </b-row>

                    <div v-if="einselected=='EINVOICE' && eivcodeselected=='NATURECODE'">
                        <b-form-group class="mb-0 pt-0 pt-md-4">
                            <label>自然人憑證條碼 <span class="text-danger">*</span></label>
                            <b-form-input

                                    v-model="eindata.naturecode"
                                    maxlength="16"
                                    placeholder="長度 16 個字元，由 2 碼大寫字母加上 14 碼數字組成"
                                    @change="checkvalue('naturecode')"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="eindata.naturecodecheck">
                                {{ eindata.naturecodemsg }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div v-if="einselected=='EINVOICE' && eivcodeselected=='PHONECODE'">
                        <b-form-group class="mb-0 pt-0 pt-md-4">
                            <label>手機條碼<span class="text-danger">*</span></label>
                            <b-form-input

                                    v-model="eindata.phonecode"
                                    maxlength="8"
                                    placeholder="長度 8 個字元，由斜線（/）加上 7 碼 +、-、.、數字及大寫字母組成！"
                                    @change="checkvalue('phonecode')"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="eindata.phonecodecheck">
                                {{ eindata.phonecodemsg }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div v-if="einselected=='COMPANYID'">
                        <b-row class="pt-0 pt-md-4">

                            <b-col cols="12" md="6">

                                <b-form-group
                                        class="mb-0"
                                >
                                    <label>統一編號<span class="text-danger">*</span></label>
                                    <b-form-input

                                            v-model="companydata.id"
                                            maxlength="8"
                                            placeholder="送出後無法更改，請務必確認"
                                            @change="checkvalue('companyid')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="companydata.idcheck">
                                        {{ companydata.idmsg }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                            <b-col cols="12" md="6">

                                <b-form-group
                                        class="mb-0"
                                >
                                    <label>發票抬頭<span class="text-danger">*</span></label>
                                    <b-form-input

                                            v-model="companydata.name"
                                            placeholder="請輸入發票抬頭"
                                            @change="checkvalue('companyname')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="companydata.namecheck">
                                        {{ companydata.namemsg }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <label class="pt-3">公司地址<span class="text-danger">*</span></label>
                        <b-row>
                            <b-col cols="12" md="10">

                                <b-form-group class="mb-0">

                                    <b-form-input

                                            v-model="companydata.address"
                                            placeholder="請輸入公司地址"
                                            @change="checkvalue('address')"
                                    ></b-form-input>
                                    <b-form-invalid-feedback :state="companydata.addresscheck">
                                        {{ companydata.addressmsg }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>
                            <b-col cols="5" md="2">

                                <b-form-group class="mb-0">

                                    <b-form-input

                                            maxlength="8"
                                            v-model="companydata.addresscode"
                                            placeholder="郵遞區號"
                                    ></b-form-input>

                                </b-form-group>

                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="bg-white p-2 p-md-3  pt-3 shadow-sm rounded ">
                    <h5 class="text-primary">訂單明細</h5>
                    <hr>
                    <p>{{ title }}</p>
                    <div class="d-flex justify-content-between text-muted">
                        <p>售價</p>
                        <p>NT${{ price }}</p>
                    </div>
                    <h3 class="w-100 text-right text-primary ">NT${{ price }}</h3>
                    <hr>
                    <b-button v-if="payStatus"  variant="success" size="lg" @click="formCheck" block>確認送出</b-button>
                    <b-button v-else disabled variant="dark" size="lg"  block>系統維護中，暫停交易</b-button>
                    <FinalCheckModel ref="FinalModel" :shopcart="shopcart" :orderdata="orderpurchase" v-on:sendAction="gotoEcpay" ></FinalCheckModel>
                </div>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import FinalCheckModel from '@/components/payment/FinalCheckModel.vue'
import { toastsModel, toCurrency } from '@/service/commuse'

export default {
  name: 'CheckOut',
  components: {PageHeader,FinalCheckModel},
  computed: {
    ...mapState(['shopcart', 'profiledata','orderpurchase']),
    title: function () {return Object.keys(this.shopcart).length !== 0 ? this.shopcart.title : ''},
    price: function () {return Object.keys(this.shopcart).length !== 0 ? toCurrency(this.shopcart.price) : ''},
    puid:function () {return Object.keys(this.shopcart).length !== 0 ? this.shopcart.product_id : '';},

  },
  mounted () {

    if (Object.keys(this.shopcart).length == 0) {
      this.$router.push('/Payment/PlanCart')
    }else{
      this.appStatus()
    }
  },
  data () {
    return {

      payStatus:false,
      payselected: 'CREDIT',
      payway: [
        {value: 'CREDIT', text: '信用卡'},
        // {value: 'ATM', text: 'ATM 轉帳', disabled: true},
      ],
      bankselected: '822',
      atmbank: [
        {value: '822', text: '822 中國信託'},
        {value: '812', text: '812 台新銀行'},
        {value: '808', text: '808 玉山銀行'},
        {value: '004', text: '004 台灣銀行'},
        {value: '012', text: '012 台北富邦'},
        {value: '005', text: '005 土地銀行'},
        {value: '013', text: '013 國泰世華銀行'},
        {value: '814', text: '814 大眾銀行'},
        {value: '007', text: '007 第一銀行'},
      ],
      einselected: 'EINVOICE',
      einvoice: [
        {value: 'EINVOICE', text: '電子發票'},
        {value: 'DONATION', text: '捐贈發票'},
        {value: 'COMPANYID', text: '統編發票'},
      ],
      eivcodeselected: 'NAMECIRCLE',
      einvoicecode: [
        {value: 'NAMECIRCLE', text: '儲存在姓名DNA，中獎後寄信通知'},
        {value: 'NATURECODE', text: '自然人憑證條碼'},
        {value: 'PHONECODE', text: '手機條碼'},
      ],
      donationselected: '3339',
      donatuonorg: [
        {value: '25885', text: '財團法人伊甸社會福利基金會（25885）'},
        {value: '5229', text: '社團法人台灣導盲犬協會（5299）'},
        {value: '3339', text: '社團法人教育及兒童青少年發展協會（3339）'},
      ],
      formData: {
        clientname: '',
        namecheck: null,
        namemsg: '',
        clientmail: '',
        emailcheck: null,
        emailmsg: '',
      },
      companydata: {
        id: '',
        idcheck: null,
        idmsg: '',
        name: '',
        namecheck: null,
        namemsg: '',
        address: '',
        addresscheck: null,
        addressmsg: '',
        addresscode: '',
      },
      eindata: {
        phonecode: '',
        phonecodecheck: null,
        phonecodemsg: '',
        naturecode: '',
        naturecodecheck: null,
        naturecodemsg: ''
      },
      orderdata:null

    }
  },
  methods: {
    checkvalue (way) {
      switch (way) {
        case 'name':
          if (this.formData.clientname.length == 0) {
            this.formData.namemsg = '姓名為必填欄位'
            this.formData.namecheck = false
          }

          let nameRule = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
          if (!nameRule.test(this.formData.clientname)) {
            this.formData.namemsg = '請輸入正確姓名'
            this.formData.namecheck = false
          } else {
            this.formData.namecheck = true
          }
          break
        case 'email':

          let emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
          if (this.formData.clientmail.length == 0) {
            this.formData.emailmsg = '請輸入您的信箱'
            this.formData.emailcheck = false
          } else if (!emailRule.test(this.formData.clientmail)) {
            this.formData.emailmsg = '請輸入正確信箱格式'
            this.formData.emailcheck = false
          } else {
            this.formData.emailcheck = true
          }
          break
        case 'companyid':
          let idRule = /[0-9]+/
          if (!idRule.test(this.companydata.id)) {
            this.companydata.idmsg = '請輸入統一編號'
            this.companydata.idcheck = false
          } else {
            this.companydata.idcheck = true
          }
          break
        case 'address':
          let addressRule = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
          if (!addressRule.test(this.companydata.address)) {
            this.companydata.addressmsg = '請輸入公司地址'
            this.companydata.addresscheck = false
          } else {
            this.companydata.addresscheck = true
          }
          break
        case 'companyname':
          let companynameRule = /^[A-Za-z0-9\u4e00-\u9fa5]+$/
          if (!companynameRule.test(this.companydata.name)) {
            this.companydata.namemsg = '請輸入發票抬頭'
            this.companydata.namecheck = false
          } else {
            this.companydata.namecheck = true
          }
          break
        case 'naturecode':
          let naturecodeRule = /^[a-zA-Z]{2}[0-9]{14}$/
          if (this.eindata.naturecode.length == 0) {
            this.eindata.naturecodemsg = '請填寫自然人憑證條碼'
            this.eindata.naturecodecheck = false
          }else if (!naturecodeRule.test(this.eindata.naturecode)) {
            this.eindata.naturecodemsg = '不正確的自然人憑證條碼格式'
            this.eindata.naturecodecheck = false
          } else {
            this.eindata.naturecodecheck = true
          }
          break
        case 'phonecode':
          let phonecodeRule = /^[/]{1}[0-9a-zA-Z-.+]{7}$/
          if (this.eindata.phonecode.length == 0) {
            this.eindata.phonecodemsg = '請填寫手機條碼'
            this.eindata.phonecodecheck = false
          }else if (!phonecodeRule.test(this.eindata.phonecode)) {
            this.eindata.phonecodemsg = '不正確的手機條碼格式'
            this.eindata.phonecodecheck = false
          } else {
            this.eindata.phonecodecheck = true
          }
          break
      }

    },
    formCheck () {
      this.checkvalue('name')
      this.checkvalue('email')
      if (!this.formData.emailcheck) {
        toastsModel(this, this.formData.emailmsg)
      }
      if (!this.formData.namecheck) {
        toastsModel(this, this.formData.namemsg)
      }

      if (this.einselected == 'COMPANYID') {
        this.checkvalue('companyid')
        this.checkvalue('address')
        this.checkvalue('companyname')
        if (!this.companydata.idcheck) {
          toastsModel(this, this.companydata.idmsg)
        }
        if (!this.companydata.addresscheck) {
          toastsModel(this, this.companydata.addressmsg)
        }
        if (!this.companydata.namecheck) {
          toastsModel(this, this.companydata.namemsg)
        }
      }
      if (this.einselected == 'EINVOICE' && this.eivcodeselected == 'NATURECODE') {
        this.checkvalue('naturecode')
        if (!this.eindata.naturecodecheck) {
          toastsModel(this,  this.eindata.naturecodemsg)
        }
      }
      if (this.einselected == 'EINVOICE' && this.eivcodeselected == 'PHONECODE') {
        this.checkvalue('phonecode')
        if (!this.eindata.phonecodecheck) {
          toastsModel(this,  this.eindata.phonecodemsg )
        }
      }

      if (
        this.formData.emailcheck == true && this.formData.namecheck == true
      ) {
        let orderData = {
          Name: this.formData.clientname,
          Email: this.formData.clientmail,
          Eintype: '',
          Donation: '',
          LoveCode: '',
          CustomerIdentifier: '',
          CustomerName: '',
          CustomerAddr: '',
          CustomerAddrCode: '',
          CarruerType: '',
          CarruerNum: '',
          Puid:this.puid,
          PaymentType:this.payselected
        }
        switch (this.einselected) {
          case 'EINVOICE':
            if (this.eindata.naturecodecheck && this.eivcodeselected == 'NATURECODE') {
              orderData.Eintype='NATURECODE'
              orderData.CarruerType = 2
              orderData.CarruerNum = this.eindata.naturecode
              this.finalCheck(orderData)
            }
            if (this.eindata.phonecodecheck && this.eivcodeselected == 'PHONECODE') {
              orderData.Eintype='PHONECODE'
              orderData.CarruerType = 3
              orderData.CarruerNum = this.eindata.phonecode
              this.finalCheck(orderData)

            }

            if (this.eivcodeselected == 'NAMECIRCLE') {
              orderData.Eintype='NAMECIRCLE'
              orderData.CarruerType = ''
              orderData.CarruerNum = ''
              this.finalCheck(orderData)
            }

            break
          case 'DONATION':
            orderData.Eintype='DONATION'
            orderData.Donation = 1
            orderData.LoveCode = this.donationselected
            this.finalCheck(orderData)

            break
          case 'COMPANYID':

            if (this.companydata.idcheck && this.companydata.addresscheck && this.companydata.namecheck) {
              orderData.Eintype='COMPANYID'
              orderData.CustomerIdentifier = this.companydata.id
              orderData.CustomerName = this.companydata.name
              orderData.CustomerAddr = this.companydata.address
              orderData.CustomerAddrCode = this.companydata.addresscode
              this.finalCheck(orderData)
            }
            break
        }

      }
    },
    finalCheck(data){
      this.$store.dispatch('actionOrderPurchase',data)
      this.$refs.FinalModel.toggleModal()

      this.orderdata = data

      // console.log( this.$refs)
      // this.$refs.FinalCheckModel.show()
    },
    gotoEcpay () {


      // this.$router.push('/Payment/Ecpay');
      this.$store.dispatch('actionECpay',this.orderdata
      ).then((res) => {
        document.open();
        document.write(res);
        document.close();
      }).catch((res) => {
        // this.loading = false
      })

    },
    loadAccountData () {
      this.formData.clientname = this.profiledata.first_name + this.profiledata.last_name
      this.formData.clientmail = this.profiledata.mail === null?'':this.profiledata.mail

    },
    appStatus(){

      this.$store.dispatch('actionGetAppStatus',{})
        .then((res) => {
          console.log(res)
          this.payStatus = res.data.payment

        })
        .catch((res) => {

        })
    }
  }
}
</script>

